import { DataCard } from 'components';
import { CardField } from 'components/DataCard/ui/Field';
import type { Team } from 'models/team';

interface TeamCardProps {
  team?: Pick<Team, 'id' | 'name' | 'teamLeads'>;
}

const TeamCard = ({ team }: TeamCardProps) => {
  const fields: CardField[] = [
    {
      label: 'Название',
      value: team?.name,
    },
    {
      label: team?.teamLeads && team.teamLeads.length > 1 ? 'Тимлиды' : 'Тимлид',
      value:
        team?.teamLeads && team.teamLeads.length > 0
          ? team.teamLeads.map((tl) => tl.name).join(', ')
          : 'Не назначен',
    },
  ];

  return <DataCard allowEdit={false} title="Звено" fields={fields} />;
};

export default TeamCard;
